module.exports = __webpack_public_path__ + "static/media/star-lsa.ff59b515.png";